import React, { Component } from 'react';
import { Row, Col, Panel } from 'react-bootstrap';
import I from 'react-fontawesome';
import {
  ResponsiveContainer,
  AreaChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Area,
  BarChart,
  Bar,
  Legend,
  PieChart,
  Pie,
  ComposedChart,
  Line,
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
} from 'recharts';

const composedData = [
  { name: 'Page A', uv: 590, pv: 800, amt: 1400 },
  { name: 'Page B', uv: 868, pv: 967, amt: 1506 },
  { name: 'Page C', uv: 1397, pv: 1098, amt: 989 },
  { name: 'Page D', uv: 1480, pv: 1200, amt: 1228 },
  { name: 'Page E', uv: 1520, pv: 1108, amt: 1100 },
  { name: 'Page F', uv: 1400, pv: 680, amt: 1700 },
];

const areaData = [
  { name: 'Page A', uv: 4000, pv: 2400, amt: 2400 },
  { name: 'Page B', uv: 3000, pv: 1398, amt: 2210 },
  { name: 'Page C', uv: 2000, pv: 9800, amt: 2290 },
  { name: 'Page D', uv: 2780, pv: 3908, amt: 2000 },
  { name: 'Page E', uv: 1890, pv: 4800, amt: 2181 },
  { name: 'Page F', uv: 2390, pv: 3800, amt: 2500 },
  { name: 'Page G', uv: 3490, pv: 4300, amt: 2100 },
];

const barData = [
  { name: 'Page A', uv: 4000, pv: 2400, amt: 2400 },
  { name: 'Page B', uv: 3000, pv: 1398, amt: 2210 },
  { name: 'Page C', uv: 2000, pv: 9800, amt: 2290 },
  { name: 'Page D', uv: 2780, pv: 3908, amt: 2000 },
  { name: 'Page E', uv: 1890, pv: 4800, amt: 2181 },
  { name: 'Page F', uv: 2390, pv: 3800, amt: 2500 },
  { name: 'Page G', uv: 3490, pv: 4300, amt: 2100 },
];

const pieData1 = [
  { name: 'Group A', value: 400 },
  { name: 'Group B', value: 300 },
  { name: 'Group C', value: 300 },
  { name: 'Group D', value: 200 },
];

const pieData2 = [
  { name: 'A1', value: 100 },
  { name: 'A2', value: 300 },
  { name: 'B1', value: 100 },
  { name: 'B2', value: 80 },
  { name: 'B3', value: 40 },
  { name: 'B4', value: 30 },
  { name: 'B5', value: 50 },
  { name: 'C1', value: 100 },
  { name: 'C2', value: 200 },
  { name: 'D1', value: 150 },
  { name: 'D2', value: 50 },
];

const radarData = [
  { subject: 'Math', A: 120, B: 110, fullMark: 150 },
  { subject: 'Chinese', A: 98, B: 130, fullMark: 150 },
  { subject: 'English', A: 86, B: 130, fullMark: 150 },
  { subject: 'Geography', A: 99, B: 100, fullMark: 150 },
  { subject: 'Physics', A: 85, B: 90, fullMark: 150 },
  { subject: 'History', A: 65, B: 85, fullMark: 150 },
];

class ChartRechartsPage extends Component {
  render() {
    return (
      <div className="content-wrapper">
        <section className="content-header">
          <h1 className="content-title">
            Charts
            <small>Recharts</small>
          </h1>
          <ol className="breadcrumb">
            <li>
              <a>
                <I name="dashboard" /> Home
              </a>
            </li>
            <li className="active">Charts</li>
          </ol>
        </section>
        <section className="content">
          <Row>
            <Col md={12}>
              <Panel header="Composed Chart">
                <ResponsiveContainer height={300}>
                  <ComposedChart width={900} height={300} data={composedData}>
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <CartesianGrid stroke="#f5f5f5" />
                    <Area
                      type="monotone"
                      dataKey="amt"
                      fill="#1AD6FD"
                      stroke="#1AD6FD"
                    />
                    <Bar dataKey="pv" barSize={20} fill="#1D77EF" />
                    <Line type="monotone" dataKey="uv" stroke="#FF3B30" />
                  </ComposedChart>
                </ResponsiveContainer>
              </Panel>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Panel header="Area Chart">
                <ResponsiveContainer height={300}>
                  <AreaChart width={600} height={300} data={areaData}>
                    <XAxis dataKey="name" />
                    <YAxis />
                    <CartesianGrid strokeDasharray="3 3" />
                    <Tooltip />
                    <Area
                      type="monotone"
                      dataKey="uv"
                      stackId="1"
                      stroke="#1AD6FD"
                      fill="#1AD6FD"
                    />
                    <Area
                      type="monotone"
                      dataKey="pv"
                      stackId="1"
                      stroke="#FF3B30"
                      fill="#FF3B30"
                    />
                    <Area
                      type="monotone"
                      dataKey="amt"
                      stackId="1"
                      stroke="#FF9500"
                      fill="#FF9500"
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </Panel>
              <Panel header="Donut Chart">
                <ResponsiveContainer height={300}>
                  <PieChart width={600} height={600}>
                    <Pie
                      data={pieData1}
                      cx="50%"
                      cy="50%"
                      outerRadius={50}
                      fill="#1AD6FD"
                    />
                    <Pie
                      data={pieData2}
                      cx="50%"
                      cy="50%"
                      innerRadius={60}
                      outerRadius={80}
                      fill="#1D77EF"
                      label
                    />
                  </PieChart>
                </ResponsiveContainer>
              </Panel>
            </Col>

            <Col md={6}>
              <Panel header="Bar Chart">
                <ResponsiveContainer height={300}>
                  <BarChart width={600} height={300} data={barData}>
                    <XAxis dataKey="name" />
                    <YAxis />
                    <CartesianGrid strokeDasharray="3 3" />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="pv" stackId="a" fill="#1AD6FD" />
                    <Bar dataKey="uv" stackId="a" fill="#1D77EF" />
                  </BarChart>
                </ResponsiveContainer>
              </Panel>
              <Panel header="Line Chart">
                <ResponsiveContainer height={300}>
                  <RadarChart
                    cx="50%"
                    cy="50%"
                    outerRadius={90}
                    width={300}
                    height={300}
                    data={radarData}
                  >
                    <Radar
                      name="Mike"
                      dataKey="A"
                      stroke="#1AD6FD"
                      fill="#1AD6FD"
                      fillOpacity={0.6}
                    />
                    <Radar
                      name="Lily"
                      dataKey="B"
                      stroke="#1D77EF"
                      fill="#1D77EF"
                      fillOpacity={0.6}
                    />
                    <PolarGrid />
                    <Legend />
                    <PolarAngleAxis dataKey="subject" />
                    <PolarRadiusAxis angle={30} domain={[0, 150]} />
                  </RadarChart>
                </ResponsiveContainer>
              </Panel>
            </Col>
          </Row>
        </section>
      </div>
    );
  }
}

export default ChartRechartsPage;



// WEBPACK FOOTER //
// ./src/pages/ChartRechartsPage.js